/* Raw dock tab and its events table (W2-05). Design tokens only. */

.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  height: 100%;
  min-height: 0;
  padding: var(--space-2) var(--space-3);
  overflow: auto;
  color: var(--color-text);
  font-size: var(--text-md);
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.headerTitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
}

.headerActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

.muted {
  color: var(--color-text-subtle);
  font-size: var(--text-sm);
}

.note {
  margin: 0;
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.schema {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-0) var(--space-2);
  border-radius: var(--radius-pill);
  font-size: var(--text-sm);
}

.schema[data-state='ok'] {
  background: var(--color-success-muted);
  color: var(--color-success);
}

.schema[data-state='warning'] {
  background: var(--color-warning-muted);
  color: var(--color-warning);
}

.schema[data-state='error'] {
  background: var(--color-danger-muted);
  color: var(--color-danger);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
}

.banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-3);
  border: var(--border-width) solid var(--color-warning);
  border-radius: var(--radius-sm);
  background: var(--color-warning-muted);
  font-size: var(--text-sm);
}

.editor {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--space-2);
  min-height: 0;
}

.editorLabel {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.area {
  flex: 1 1 auto;
  min-height: calc(160px * var(--ui-scale));
  padding: var(--space-2);
  border: var(--border-width) solid var(--color-border-input);
  border-radius: var(--radius-sm);
  background: var(--color-surface-sunken);
  color: var(--color-text);
  font-family: var(--font-mono);
  font-size: var(--text-sm);
  line-height: var(--leading-normal);
  tab-size: 2;
  resize: vertical;
  white-space: pre;
}

.area:focus-visible {
  outline: var(--focus-ring-width) solid var(--color-focus-ring);
  outline-offset: var(--focus-ring-offset);
}

.area[aria-invalid='true'] {
  border-color: var(--color-danger);
}

.problems {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  max-height: calc(140px * var(--ui-scale));
  margin: 0;
  padding: 0;
  overflow: auto;
  list-style: none;
  font-size: var(--text-sm);
}

.problems li {
  display: flex;
  align-items: flex-start;
  gap: var(--space-1);
}

.problems li[data-level='error'] {
  color: var(--color-danger);
}

.problems li[data-level='warning'] {
  color: var(--color-warning);
}

.problemButton {
  padding: 0;
  border: none;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.problemButton:disabled {
  cursor: default;
}

.problemButton:focus-visible {
  outline: var(--focus-ring-width) solid var(--color-focus-ring);
  outline-offset: var(--focus-ring-offset);
}

/* events table */

.table {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--space-1);
  min-height: 0;
}

.tableBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.tableHead,
.tableRow {
  display: grid;
  grid-template-columns:
    36px repeat(2, minmax(84px, 1fr)) repeat(2, minmax(64px, 1fr)) 56px minmax(72px, 0.8fr) minmax(96px, 1.2fr)
    44px minmax(88px, 1fr);
  align-items: center;
  gap: var(--space-2);
  font-family: var(--font-mono);
  font-size: var(--text-xs);
}

.tableHead {
  padding: 0 var(--space-2);
  color: var(--color-text-muted);
  font-family: var(--font-sans);
  font-weight: var(--weight-semibold);
}

.tableBody {
  flex: 1 1 auto;
  min-height: calc(160px * var(--ui-scale));
}

.tableRow {
  width: 100%;
}

.tableRow span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tableRow[data-origin='padding'],
.tableRow[data-origin='bakePiece'] {
  color: var(--color-text-muted);
}

.cellIndex {
  color: var(--color-text-subtle);
}

.origin {
  font-family: var(--font-sans);
}
